module.exports = __webpack_public_path__ + "img/footer_notification--active.26291ba3.svg";